import React from 'react';

export const TeamCalendarSummary = ({ calendar, t, testId = 'team-calendar' }) => {
  if (!calendar) return null;
  const number = v => v === null || v === undefined ? '—' : v.toLocaleString();
  return <section data-testid={testId} className="min-w-0 space-y-3">
    <h2 className="text-lg font-semibold text-zinc-100" data-testid={`${testId}-title`}>{t('Team Calendar — Training Distribution', 'Calendario Squadra — Distribuzione Allenamento')}</h2>
    <div className="flex flex-wrap gap-6 text-sm">
      <p data-testid={`${testId}-sessions`}>{t('Unique team sessions', 'Sessioni uniche squadra')}: <b>{calendar.unique_session_count}</b></p>
      <p data-testid={`${testId}-minutes`}>{t('Calendar minutes', 'Minuti calendario')}: <b>{number(calendar.total_calendar_minutes)}</b></p>
    </div>
    {!!calendar.missing_duration_sessions && <p className="text-amber-300 text-xs" data-testid={`${testId}-missing`}>
      {t('Sessions with missing duration', 'Sessioni con durata mancante')}: {calendar.missing_duration_sessions}
    </p>}
    <div className="overflow-x-auto">
      <table className="w-full text-xs text-left" data-testid={`${testId}-table`}>
        <thead className="text-zinc-400"><tr>
          <th className="py-2">{t('Session Type', 'Tipo sessione')}</th>
          <th className="px-2">{t('Unique team sessions', 'Sessioni uniche squadra')}</th>
          <th className="px-2">{t('Calendar minutes', 'Minuti calendario')}</th>
          <th className="pl-2">{t('Calendar share', 'Quota calendario')}</th>
        </tr></thead>
        <tbody>{calendar.session_types.map(row => <tr key={row.type} className="border-t border-zinc-800" data-testid={`${testId}-type-${row.type.toLowerCase()}`}>
          <td className="py-2 break-words">{row.type}</td><td className="px-2">{row.unique_session_count}</td>
          <td className="px-2">{number(row.calendar_minutes)}</td><td className="pl-2">{row.percentage == null ? '—' : `${row.percentage}%`}</td>
        </tr>)}</tbody>
      </table>
    </div>
  </section>;
};